import { request } from "../utils/request"


/**
 * fetch 分页数，返回的数据均关联企业
 * @param params 
 * @returns 
 */
export const getTerminals = (params: { cmp?: number | null, proj?: number | null, name?: string | null, page: number, limit: number }) => {
    return request.get('/terminal/', { params })
}

/**
 * 新建终端设备
 * @param data 
 * @returns 
 */
export const createTerminal = (data: { name: string, company: number | null, project: number | null }) => {
    return request.post('/terminal/create', data)
}

/**
 * 更新终端设备
 * @param data 
 * @returns 
 */
export const updateTerminal = (data: { id: number; name: string, company: number | null, project: number | null }) => {
    return request.post('/terminal/update', data)
}


/**
 * -------------------------------------------------------------
 * 终端 terminal 和传感器 sensor 分界线
 * -------------------------------------------------------------
 */

/**
 * fetch 分页数，返回的数据均关联企业
 * @param params 
 * @returns 
 */
export const getSensors = (params: { cmp?: number | null, proj?: number | null, name?: string | null, page: number, limit: number }) => {
    return request.get('/sensor/', { params })
}

/**
 * fetch sensor types
 * @returns 
 */
export const getSensorTypes = () => {
    return request.get('/sensor/types')
}

/**
 * 新建终端设备
 * @param data 
 * @returns 
 */
export const createSensor = (data: { name: string, type: number | null, company: number | null, project: number | null }) => {
    return request.post('/sensor/create', data)
}

/**
 * 更新终端设备
 * @param data 
 * @returns 
 */
export const updateSensor = (data: { id: number; name: string, type: number | null, company: number | null, project: number | null }) => {
    return request.post('/sensor/update', data)
}